//calculate index of price band to appear based on array position (array starts from 0) and if it is reverse or not

import { NumberOfBands } from "../config";

export const CalcPriceBandIndex = (position, isReverse) =>
  isReverse ? NumberOfBands - position : position + 1;
